module.exports = __webpack_public_path__ + "assets/2c1d0c8160502efbb8f2338714a5f79f.png";